import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";
import get from "lodash/get";

import { Field, FieldError, FieldLabel } from "@/components/ui/field";
import { PhoneInput } from "@/components/ui/phone-input";

import { REQUIRED_MARK } from "./fieldClasses";

// The shadcn PhoneInput emits E.164 ("+13304284366") and "" when cleared, so
// the field holds a string like the text inputs do.
const FormPhoneInput = ({
  name,
  label,
  required,
  placeholder,
  disabled,
  defaultCountry = "US",
  id,
  ...rest
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = get(errors, name);
  const inputId = id ?? name;
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Field data-invalid={error ? true : undefined}>
          {label && (
            <FieldLabel
              htmlFor={inputId}
              className={required ? REQUIRED_MARK : undefined}
            >
              {label}
            </FieldLabel>
          )}
          <PhoneInput
            {...rest}
            id={inputId}
            name={field.name}
            international
            defaultCountry={defaultCountry}
            placeholder={placeholder}
            disabled={disabled}
            value={field.value}
            onChange={field.onChange}
            onBlur={field.onBlur}
            aria-required={required || undefined}
            aria-invalid={error ? true : undefined}
          />
          <FieldError>{error?.message}</FieldError>
        </Field>
      )}
    />
  );
};

FormPhoneInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.node,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  defaultCountry: PropTypes.string,
  id: PropTypes.string,
};

export default FormPhoneInput;
